{
    "SidebarMenu_Reporting_Reporting": "Berichterstattung",
    "SidebarMenu_Reporting_Insights": "Einblicke",
    "SidebarMenu_Reporting_Presence": "Gegenwart",
    "SidebarMenu_FastProvisioning_EnterpriseManagement": "Unternehmen hinzufügen +",
    "SidebarMenu_FastProvisioning_UserManagement": "Benutzerverwaltung",
    "SidebarMenu_FastProvisioning_QueueManagement": "Warteschlangenverwaltung",
    "SidebarMenu_Admin_Devices": "Geräte",
    "SidebarMenu_Admin_Agents": "Agenten",
    "SidebarMenu_Admin_Directory": "Verzeichnis",
    "SidebarMenu_Admin_Codes": "Codes",
    "SidebarMenu_Admin_Partitions": "Partitionen",
    "SidebarMenu_Admin_TelephonyServers": "Telefonieserver",
    "SidebarMenu_Admin_CME": "CME",
    "SidebarMenu_Admin_AppUsers": "Benutzer",
    "SidebarMenu_Admin_Recording": "Aufnahme",
    "SidebarMenu_Admin_Messages": "Nachrichten",
    "SidebarMenu_Admin_Database": "Datenbank",
    "SidebarMenu_StatusTools_Licences": "Lizenzen",
    "SidebarMenu_StatusTools_Logging": "Protokollierung",
    "SidebarMenu_StatusTools_LogManagement": "Protokollverwaltung",
    "SidebarMenu_StatusTools_AuditTrail": "Prüfpfad",
    "SidebarMenu_StatusTools_TelephoneModuleStatus": "TelSys-Modulstatus",
    "SidebarMenu_StatusTools_CallControl": "Anrufsteuerung",
    "SidebarMenu_StatusTools_ServerStatus": "Serverstatus",
    "NAME": "SidebarMenu",
    "SidebarMenu_Admin_ClientConfig": "Client-Konfiguration",
    "SidebarMenu_Admin_CRM_Configuration": "CRM-Konfiguration"
}